import { render, staticRenderFns } from "./TitleMore.vue?vue&type=template&id=16795220&scoped=true&"
import script from "./TitleMore.vue?vue&type=script&lang=js&"
export * from "./TitleMore.vue?vue&type=script&lang=js&"
import style0 from "./TitleMore.vue?vue&type=style&index=0&id=16795220&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16795220",
  null
  
)

export default component.exports